import {
  Component,
  ElementRef,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { Subscription } from 'rxjs';
import { TopbarService } from '../topbar.service';
import { Sidebar } from 'primeng/sidebar';
import { SubscriptionPackage, TipPristupa } from '@kodit/core/data-api';
import { AuthService } from '@kodit/core/services';
import { Router } from '@angular/router';

@Component({
  selector: 'kodit-podesavanja-sidebar',
  templateUrl: './podesavanja-sidebar.component.html',
  styleUrls: ['./podesavanja-sidebar.component.scss'],
})
export class PodesavanjaSidebarComponent implements OnInit, OnDestroy {
  private _subs: Subscription = new Subscription();
  showSidebar: boolean;
  clientPackageId: string;
  el: any;
  showcloseIcon = false;

  /** Props */
  shouldDisplayKompanijaCard: boolean;
  shouldDisplayKorisnickiNaloziCard: boolean;
  shouldDisplayApiMenadzmentCard: boolean;
  shouldDisplayRacunCard: boolean;
  shouldDisplayListeCard: boolean;
  shouldDisplayOznakeCard: boolean;
  shouldDisplayPocetnaStanjaCard: boolean;
  shouldDisplayFiskalnaCard: boolean;
  shouldDisplayArhivskaCard: boolean;

  @ViewChild('PodesavanjaSidebar') sidebarRef: Sidebar;

  constructor(
    private service: TopbarService,
    private _authService: AuthService,
    private _router: Router
  ) {}

  ngOnInit(): void {
    this._loadDisplays();
    this._subs.add(
      this.service.getShowPodesavanjaSidebar.subscribe((show) => {
        if (show) {
          this._loadDisplays();
        }
        this.showSidebar = show;
      })
    );
  }

  private _loadDisplays() {
    const isAdmin = this._authService.hasClaim(
      TipPristupa[TipPristupa.ADMIN_CRUD]
    );
    //Kompanija
    this.shouldDisplayKompanijaCard = isAdmin;
    //Korisnicki nalozi
    this.shouldDisplayKorisnickiNaloziCard = isAdmin;
    //Api menadzment
    this.shouldDisplayApiMenadzmentCard = isAdmin;
    //Racuni
    this.shouldDisplayRacunCard =
      isAdmin &&
      this._authService.hasPackage([
        SubscriptionPackage[SubscriptionPackage.MALOPRODAJA],
        SubscriptionPackage[SubscriptionPackage.VELEPRODAJA],
        SubscriptionPackage[SubscriptionPackage.EFAKTURE],
        SubscriptionPackage[SubscriptionPackage.BESPLATNO],
        SubscriptionPackage[SubscriptionPackage.EOTPREMNICE],
      ]);
    //Registri (sifarnici vide i kasir i magacioner)
    this.shouldDisplayListeCard =
      this._authService.hasClaim([
        TipPristupa[TipPristupa.ADMIN_CRUD],
        TipPristupa[TipPristupa.FISKALNI_RACUN_CRUD],
        TipPristupa[TipPristupa.MAGACIN_CRUD],
      ]) &&
      this._authService.hasPackage([
        SubscriptionPackage[SubscriptionPackage.EFAKTURE],
        SubscriptionPackage[SubscriptionPackage.MALOPRODAJA],
        SubscriptionPackage[SubscriptionPackage.VELEPRODAJA],
        SubscriptionPackage[SubscriptionPackage.FISKALNA_KASA],
        SubscriptionPackage[SubscriptionPackage.BESPLATNO],
        SubscriptionPackage[SubscriptionPackage.EOTPREMNICE],
      ]);
    //Oznake
    this.shouldDisplayOznakeCard =
      isAdmin &&
      this._authService.hasPackage([
        SubscriptionPackage[SubscriptionPackage.EFAKTURE],
        SubscriptionPackage[SubscriptionPackage.MALOPRODAJA],
        SubscriptionPackage[SubscriptionPackage.VELEPRODAJA],
      ]);
    //Pocetna stanja
    this.shouldDisplayPocetnaStanjaCard =
      isAdmin &&
      this._authService.hasPackage([
        SubscriptionPackage[SubscriptionPackage.EFAKTURE],
        SubscriptionPackage[SubscriptionPackage.VELEPRODAJA],
        SubscriptionPackage[SubscriptionPackage.ARHIVA],
        SubscriptionPackage[SubscriptionPackage.FISKALNA_KASA],
        SubscriptionPackage[SubscriptionPackage.MALOPRODAJA],
      ]);
    //Fiskalna
    this.shouldDisplayFiskalnaCard =
      isAdmin &&
      this._authService.hasPackage([
        SubscriptionPackage[SubscriptionPackage.MALOPRODAJA],
        SubscriptionPackage[SubscriptionPackage.FISKALNA_KASA],
      ]);
    //Arhiva
    this.shouldDisplayArhivskaCard =
      isAdmin &&
      this._authService.hasPackage(
        SubscriptionPackage[SubscriptionPackage.ARHIVA]
      );
  }

  redirectToLink(cardLink: string) {
    this.onHide();
    this._router.navigate(['/podesavanja', cardLink]);
  }

  onHide() {
    //this.service.hideNotifikacijeSidebar();
    this._destroy();
  }

  onShow() {
    this.service.hideNotifikacijeSidebar();
    this.service.hideProfileSidebar();
    this._loadDisplays();
  }

  private _destroy() {
    if (this.sidebarRef) {
      this.service.hidePodesavanjaSidebar();
      this.sidebarRef.destroyModal();
    }
  }

  ngOnDestroy() {
    this._destroy();
    // this.service.hidePodesavanjaSidebar();
    // this._subs.unsubscribe();
  }
}
